// extracted by mini-css-extract-plugin
module.exports = {"temp":"na_temp__qN9p1"};